import type { Converter } from '@automapper/core';

const nilStringConverter: Converter<null | undefined, string> = {
  convert(source) {
    return source || String();
  },
};

export default nilStringConverter;
